import { render } from "./BlockStyle.vue?vue&type=template&id=1d8dbf96&scoped=true"
import script from "./BlockStyle.vue?vue&type=script&lang=ts"
export * from "./BlockStyle.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1d8dbf96"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QIcon,QPopupProxy,QColor,QSelect});
